module.exports = __webpack_public_path__ + "media/luigi.2c94c32c.wav";